import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { padEnd, size } from 'lodash';
import SpatialNavigationWrapper from 'components/navigation/SpatialNavigationWrapper';
import KeyboardSmall from 'components/keyboard-small';
import { StyledBlock, StyledCodeInputChar } from '../StyledComponents';
import ActionsSection from '../ActionsSection';

const MAX_CODE_LENGTH = 4;
const PIN_CODE_CHAR_PLACEHOLDER = '_';

const OTPForm = (props) => {
  const { invalidMessage, buttonLabel, sectionName, onSubmit, children } = props;
  const [code, setCode] = useState('');
  const [isValid, setIsValid] = useState(true);
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);
  const cursorPosition = code.length;

  const resetInput = useCallback(() => setCode(''), []);

  const showKeyboard = useCallback(() => setIsKeyboardVisible(true), []);
  const hideKeyboard = useCallback(() => setIsKeyboardVisible(false), []);
  const onKeyboardInput = useCallback(
    (value) => {
      if (value === 'remove') {
        setCode((prev) => prev.slice(0, -1));
      } else if (value === 'close') {
        setIsValid(size(code) === MAX_CODE_LENGTH);
        setIsKeyboardVisible(false);
      } else if (size(code) < MAX_CODE_LENGTH) {
        setCode((prev) => prev + value);
      }
    },
    [code],
  );
  const onButtonClick = useCallback(() => {
    if (size(code) === MAX_CODE_LENGTH) {
      onSubmit(code);
    } else {
      setIsValid(false);
    }
  }, [code, onSubmit]);

  const value = useMemo(() => {
    const filled = padEnd(code, MAX_CODE_LENGTH, PIN_CODE_CHAR_PLACEHOLDER);

    return [...filled].map((char, idx) => {
      const isPlaceholder = char === PIN_CODE_CHAR_PLACEHOLDER;
      const isActive = idx === cursorPosition;

      return (
        <StyledCodeInputChar key={idx} isActive={isActive} isPlaceholder={isPlaceholder}>
          {char}
        </StyledCodeInputChar>
      );
    });
  }, [cursorPosition, code]);

  useEffect(() => {
    SpatialNavigationWrapper.focus(isKeyboardVisible ? '@KEYBOARD_NUM' : sectionName);
  }, [isKeyboardVisible, sectionName]);

  return (
    <StyledBlock>
      <ActionsSection sectionName={sectionName} defaultSection>
        <ActionsSection.Input
          value={value}
          isValid={!isKeyboardVisible ? isValid : true}
          invalidMessage={invalidMessage}
          align="center"
          cursor={isKeyboardVisible}
          cursorPosition={cursorPosition}
          onEnter={showKeyboard}
        />
        <ActionsSection.Button label={buttonLabel} onEnter={onButtonClick} disabled={code.length !== MAX_CODE_LENGTH} />
        {typeof children === 'function' ? children({ resetInput }) : children}
      </ActionsSection>
      {isKeyboardVisible && (
        <KeyboardSmall className="keyboard-small__phone" onEnter={onKeyboardInput} onLeave={hideKeyboard} />
      )}
    </StyledBlock>
  );
};

export default OTPForm;
